import {OverlayModule} from '@angular/cdk/overlay';
import {PortalModule} from '@angular/cdk/portal';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DialogCloseDirective} from '../../../directives/dialog-close.directive';

@NgModule({
  declarations: [DialogCloseDirective],
  imports: [CommonModule, OverlayModule, PortalModule],
  exports: [DialogCloseDirective],
})
export class DialogModule {}
